export const GST_RATE = parseInt(process.env.REACT_APP_GST_RATE || '18');